// A script recorded by Matt at WFS (Westfield Mall) on Jan 29
const script = [
  [1580341542968, 37.78455694324359, -122.40645317728358, 65, null],
  [1580341546791, 37.78455694324359, -122.40645317728358, 65, null],
  [1580341546799, 37.78454489427155, -122.40643448917078, 65, null],
  [1580341546799, 37.78454321129835, -122.40643181242413, 65, null],
  [1580341547813, 37.7846036302488, -122.40649947364717, 11.255818718569675, 2],
  [1580341548802, 37.78451629216297, -122.40637729123247, 15.399369554979087, 2],
  [1580341549894, 37.7844784950335, -122.40629819856693, 10.583428295818415, 2],
  [1580341550920, 37.7844784950335, -122.40629819856693, 11.495847938265843, 2],
  [1580341551847, 37.784478495023365, -122.40629377477774, 12.379877892340339, 2],
  [1580341552813, 37.78450369313099, -122.40635385395984, 17.300076604115763, 2],
  [1580341553818, 37.78452313660946, -122.40638954798403, 9.794930365695452, 2],
  [1580341554889, 37.7845388544886, -122.40638401783451, 8.50162115813067, 2],
  [1580341555884, 37.784544683104194, -122.40638503443704, 9.58560829771133, 2],
  [1580341556879, 37.78453848469823, -122.40637476248305, 11.051475766987775, 2],
  [1580341557861, 37.78452704622153, -122.4063642942028, 12.883632318003205, 2],
  [1580341559916, 37.78453120556734, -122.4063495462509, 13.086727597137314, 2],
  [1580341560882, 37.78452548811629, -122.40633142145616, 12.895513260238442, 2],
  [1580341561866, 37.784517340434284, -122.40631032342003, 11.576254357077067, 2],
  [1580341562818, 37.78451025930088, -122.40629755650616, 11.840889903206225, 2],
  [1580341563899, 37.78449769268209, -122.40628881478145, 11.428148283441503, 2],
  [1580341564869, 37.78448592074509, -122.406277307594, 12.045767262200636, 2],
  [1580341565903, 37.784479949848524, -122.40627216700022, 9.865395002125243, 2],
  [1580341566796, 37.78446986349944, -122.40626737416446, 10.479887787194412, 2],
  [1580341567835, 37.78446028584055, -122.40626334751806, 11.968832500965469, 2],
  [1580341568810, 37.784448939550444, -122.40626096195977, 13.858281649394193, 2],
  [1580341569906, 37.78444061298743, -122.40625857733951, 12.025246900100926, 2],
  [1580341570813, 37.784433020975264, -122.40625972068416, 10.585189341894225, 2],
  [1580341571830, 37.784425162468054, -122.406261046439, 10.844632636083151, 2],
  [1580341572911, 37.78439848741353, -122.40626470175738, 9.953840226570396, 2],
  [1580341573905, 37.784380631429975, -122.40626795608448, 11.218322534299062, 2],
  [1580341574831, 37.7843577845068, -122.40627253852611, 7.6496960636075855, 2],
  [1580341575855, 37.78434620556047, -122.40627451440787, 7.434139268588098, 2],
  [1580341576900, 37.78433990608388, -122.40628248522448, 8.127042006461846, 2],
  [1580341577852, 37.78433990608388, -122.40628248522448, 8.414683717294613, 2],
  [1580341578800, 37.784320965563076, -122.40625862919993, 9.28693987945179, 2],
  [1580341579841, 37.78431007706859, -122.40624674191444, 10.172459463550116, 2],
  [1580341580820, 37.78431470790479, -122.40621052048388, 10.938072876195685, 2],
  [1580341581853, 37.784302108863606, -122.4061945789694, 11.606224316066955, 2],
  [1580341582893, 37.78428950982028, -122.40617863746037, 12.928125962127718, 2],
  [1580341583903, 37.7842769107748, -122.40616269595677, 14.018700220124376, 2],
  [1580341584812, 37.784258012202564, -122.40613878371157, 14.156473808458772, 2],
  [1580341585892, 37.784246544321334, -122.40612285090069, 14.06856648441259, 2],
  [1580341586873, 37.7842373357326, -122.40610391686464, 10.813320911799492, 2],
  [1580341587835, 37.78422862350431, -122.40608697614962, 9.58671598684295, 2],
  [1580341588836, 37.78421803843227, -122.4060676458254, 6.873512214342347, 2],
  [1580341589840, 37.78421074615859, -122.4060547711422, 7.161799025600401, 2],
  [1580341590868, 37.78420076526979, -122.40604417072213, 7.112796685958791, 2],
  [1580341591898, 37.78419138274265, -122.40603870304406, 7.41630668754645, 2],
  [1580341592879, 37.7841787415562, -122.40603523689747, 8.314849055554308, 2],
  [1580341593830, 37.7841641329851, -122.40602719343717, 9.243114322189934, 2],
  [1580341594873, 37.784150920239625, -122.40601125199105, 10.885244532213571, 2],
  [1580341595859, 37.78412554223216, -122.40600328141328, 12.728656242822856, 2],
  [1580341596881, 37.784119242766394, -122.4060096717975, 12.128846848213136, 2],
  [1580341598916, 37.784198096919994, -122.4060735570899, 5.876337322193612, 2],
  [1580341599900, 37.78419501698664, -122.40607319863186, 15.571699294603853, 2],
  [1580341600903, 37.78419730646729, -122.40608454776442, 19.21930323428967, 2],
  [1580341601894, 37.784230477804854, -122.4062984272055, 6.406819176972959, 2],
  [1580341602845, 37.78423746750149, -122.40630893812742, 5.454139204339024, 2],
  [1580341603863, 37.78423850290963, -122.40631369004699, 6.989273857429809, 2],
  [1580341605853, 37.7842422210954, -122.40631764429604, 4.4357187732436865, 2],
  [1580341606915, 37.784247177296876, -122.40632184409544, 3.965542221813688, 2],
  [1580341607828, 37.784246158011484, -122.40632081622803, 5.463639920109945, 2],
  [1580341608794, 37.784244415999396, -122.40631856408228, 7.198799799585312, 2],
  [1580341611823, 37.78433497389688, -122.4062148225406, 5.013666447063069, 1],
  [1580341612916, 37.78433408767019, -122.40621498024943, 7.150333064534604, 1],
  [1580341613847, 37.78433188797956, -122.40621177720999, 8.262464626650614, 1],
  [1580341614878, 37.784325784211724, -122.40621739724011, 7.282290152111675, 1],
  [1580341615843, 37.784321977661726, -122.40621826214877, 8.172273128227314, 1],
  [1580341616815, 37.78430843400041, -122.40622704432376, 10.311214541860156, 1],
  [1580341617871, 37.78431344040409, -122.40624798028188, 9.584333051210141, 1],
  [1580341618810, 37.7843108317922, -122.40626148752864, 9.152338493436142, 1],
  [1580341619819, 37.784305694311975, -122.40628311068964, 8.085384192240348, 1],
  [1580341620837, 37.78431072129174, -122.40624533828925, 9.295150453841819, 1],
  [1580341621821, 37.784287654517186, -122.40630086090141, 7.48318264862287, 1],
  [1580341622822, 37.784283914646366, -122.40631267100372, 7.064685101856197, 1],
  [1580341623870, 37.784289338837674, -122.40630788852357, 8.076534479923787, 1],
  [1580341624832, 37.784281146348796, -122.40631025392724, 6.597981111176087, 1],
  [1580341625861, 37.78428276947848, -122.4063118776553, 6.744814676068818, 1],
  [1580341626817, 37.78428523293013, -122.40631157054078, 6.690440873524657, 1],
  [1580341627883, 37.78428822081831, -122.40631083230375, 6.925861268083959, 1],
  [1580341628883, 37.784289635711694, -122.40631018738956, 7.10304443332087, 1],
  [1580341629830, 37.78429671487899, -122.40630602675537, 7.426358617931645, 1],
  [1580341630847, 37.784301298889275, -122.40629925402267, 7.893161832402281, 1],
  [1580341631897, 37.78430550164645, -122.40628872972313, 8.551560861428488, 1],
  [1580341632857, 37.784312008600445, -122.406270162396, 8.827841010544658, 1],
  [1580341633809, 37.7843164679636, -122.40625660287482, 9.45001517207781, 1],
  [1580341634797, 37.78432128382159, -122.40626612576854, 11.340611862742268, 1],
  [1580341635894, 37.78433304479413, -122.406273270673, 11.10211769131407, 1],
  [1580341636817, 37.7843515024013, -122.40625218659974, 8.7748386158112, 1],
  [1580341637863, 37.784368988696045, -122.40624406873872, 7.762985788985847, 1],
  [1580341638896, 37.784381310596906, -122.40624278179006, 7.916659249022292, 1],
  [1580341639802, 37.784395436241674, -122.40624603522649, 8.84849183341895, 1],
  [1580341640799, 37.784408198013736, -122.40624942073023, 10.480492836251072, 1],
  [1580341642858, 37.784439419594555, -122.40626107354888, 9.319538523877522, 1],
  [1580341643848, 37.784453272340464, -122.40626460609305, 10.259656546848644, 1],
  [1580341648825, 37.78443920278536, -122.4062736730632, 14.070187154378631, 1],
  [1580341649889, 37.78446653360339, -122.40629121178117, 10.38937113820216, 1],
  [1580341650896, 37.78448360257335, -122.40630585124117, 9.358128192172016, 1],
  [1580341651891, 37.78449070458659, -122.40631759549649, 9.876893533549646, 1],
  [1580341652881, 37.78449878693839, -122.40633151810988, 9.36290096985821, 1],
  [1580341653902, 37.7845071045956, -122.40634477738756, 8.624518050484289, 1],
  [1580341654892, 37.78451473230354, -122.40635514863173, 8.487824526233238, 1],
  [1580341655908, 37.784521787098846, -122.40636500864544, 9.49905592984202, 1],
  [1580341656824, 37.78452812165676, -122.40637732768452, 8.55698256756268, 1],
  [1580341657900, 37.78453533668267, -122.4063899960133, 8.007866067538691, 1],
  [1580341658901, 37.78453992953582, -122.40640404869788, 8.194053171767353, 1],
  [1580341659887, 37.78455034692955, -122.40642816011311, 5.0630350857327535, 1],
  [1580341660901, 37.78455613586639, -122.40644674493416, 5.079394023936739, 1],
  [1580341661887, 37.78456202449081, -122.40646829406373, 4.679496571594769, 1],
  [1580341662877, 37.78456374046378, -122.40648397561694, 4.910760156089987, 1],
  [1580341663815, 37.78456736048546, -122.40650047040208, 5.1315357438896525, 1],
  [1580341664832, 37.784570966533146, -122.40651678958275, 5.376761991033849, 1],
  [1580341665828, 37.78457451769216, -122.40653049181768, 5.552657657703576, 1],
  [1580341666851, 37.7845756084024, -122.40653843479495, 5.713597413775724, 1],
  [1580341667888, 37.78457707310437, -122.40654090774005, 5.60028683227253, 1],
  [1580341668895, 37.784578995626816, -122.40654226587303, 5.5370686760003816, 1],
  [1580341669806, 37.784580271857145, -122.40654231799843, 5.595004405105328, 1],
  [1580341670877, 37.78458097406986, -122.40654222206955, 5.557477356623688, 1],
  [1580341671890, 37.78458146811587, -122.40654227102726, 5.645297006897462, 1],
  [1580341672800, 37.78458170310365, -122.40654168537387, 5.6024239240830624, 1],
  [1580341673889, 37.78458449131052, -122.40654220771415, 5.517495806315677, 1],
];

export default script;
